// @flow
import React from "react";
import styled from "styled-components";
import NumberPicker from "./NumberPicker";
import type { TestSchedule } from "../../lib/Types";
import ClientSuiteModal from "../products/modals/ClientSuiteModal";
import ClientSpecificationModal from "../products/modals/ClientSpecificationModal";
import Link from "../Link";
import Button from "../Button";

const ScheduleListContainer = styled.div`
  height: 100px;
  padding: 20px;
`;

const Tr = styled.tr`
  > td,
  th {
    padding: 5px;
    border-bottom: 1px dotted #ddd;
  }
`;

type Props = {
  schedule: TestSchedule,
  onlyPick: boolean,
  pickSchedule: Function
};

type State = {
  showClientSuite: boolean,
  showClientSpec: boolean
};

export default class ScheduleItem extends React.Component<Props, State> {
  state = {
    showClientSuite: false,
    showClientSpec: false,
    count: 1
  };

  showSuite = () => this.setState({ showClientSuite: true });
  showSpec = () => this.setState({ showClientSpec: true });
  hideModal = () => this.setState({ showClientSuite: false, showClientSpec: false });

  render() {
    const { showClientSuite, showClientSpec, count } = this.state;
    const { schedule, onlyPick, pickSchedule } = this.props;
    return (
      <Tr>
        <td style={{ textAlign: "center" }}>
          {!onlyPick && (
            <NumberPicker value={count} onChange={count => this.setState({ count })} />
          )}
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button
            disabled={count === 0}
            primary
            tiny
            title={onlyPick ? "Register" : "Add"}
            onClick={() => pickSchedule(schedule, count)}
          />
        </td>
        <td>
          {showClientSuite && (
            <ClientSuiteModal id={schedule.client_suite_id} onClose={this.hideModal} />
          )}
          <Link onClick={this.showSuite}>{schedule.client_suite_name}</Link>
        </td>
        <td>
          {showClientSpec && (
            <ClientSpecificationModal
              id={schedule.client_specification_id}
              onClose={this.hideModal}
            />
          )}
          <Link onClick={this.showSpec}>{schedule.client_specification_name}</Link>
        </td>
      </Tr>
    );
  }
}
